import {AdBreakInfo} from '../../../types/ads/AdBreakInfo';
import {AdInfo} from '../../../types/ads/AdInfo';

export class AdCallbacks {
  onAdStarted = (_ad: AdInfo): void => undefined;
  onAdFinished = (_ad: AdInfo): void => undefined;
  onAdBreakStarted = (_adBreak: AdBreakInfo): void => undefined;
  onAdBreakFinished = (_adBreak: AdBreakInfo): void => undefined;
  onAdClicked = (_event: AdClickedPayload): void => undefined;
  onAdError = (_event: AdErrorPayload): void => undefined;
  onAdManifestLoaded = (_event: AdManifestLoadedPayload): void => undefined;
  onAdQuartile = (_event: AdQuartilePayload): void => undefined;
  onAdSkipped = (_ad: AdInfo): void => undefined;
  onPlay = (): void => undefined;
  onPlayBeforeStartupHasSucceeded = (): void => undefined;
  onPause = (): void => undefined;
  onBeforeUnload = (): void => undefined;
}

export interface AdModuleAPI {
  readonly adCallbacks: AdCallbacks;
  isLinearAdActive: () => boolean;
  getContainer: () => HTMLElement | undefined;
  getAdModuleInfo: () => {name?: string; version?: string};
  currentTime: () => number;
  getAutoPlay(): boolean;
  registerEventListeners(): void;
  unload(): void;
}

export interface AdClickedPayload {
  clickThroughUrl?: string;
}

export interface AdErrorPayload {
  code?: number;
  message?: string;
  adBreakInfo?: AdBreakInfo;
  activeAdId?: string;
}

export interface AdManifestLoadedPayload {
  adBreakInfo?: AdBreakInfo;
  manifestDownloadTime?: number;
  isVmap: boolean;
}

export enum AdQuartile {
  FIRST_QUARTILE = 'firstQuartile',
  MIDPOINT = 'midpoint',
  THIRD_QUARTILE = 'thirdQuartile',
}

export interface AdQuartilePayload {
  quartile: AdQuartile;
}
